const defaultTheme = require('tailwindcss/defaultTheme');
const colors = require('tailwindcss/colors');

/** @type {import('tailwindcss').Config} */
module.exports = {
    content: [
        './views/*.blade.php',
        './views/**/*.blade.php',
        './javascript/*.js',
        './javascript/**/*.js',
        '../../php/classes/formbuilder.php',
    ],
    theme: {
        // Overwrite tailwind colors with our own theme colors
        colors: {
            primary: {
                DEFAULT: '#3868AB', // Strong medium blue
                300: '#749BC4',     // Lighter blue
                600: '#274F78',     // Darker blue
            },
            secondary: {
                DEFAULT: '#03213B', // Deep navy blue
                300: '#4F6374',     // Muted blue-grey
                600: '#021827',     // Very dark navy
            },
            third: {
                DEFAULT: '#38A1DE', // Bright sky blue
                300: '#74BEE8',     // Light sky blue
                600: '#2771A0',     // Deep sky blue
            },
            default: {
                DEFAULT: colors.black,
            },
            black: colors.black,
            danger: {...colors.red, DEFAULT: colors.red['500']},
            gray: {...colors.gray, DEFAULT: colors.gray['500']},
            info: {...colors.blue, DEFAULT: colors.blue['500']},
            invalid: {DEFAULT: '#dc3545'},
            rose: {...colors.rose, DEFAULT: colors.rose['500']},
            success: {...colors.green, DEFAULT: colors.green['600']},
            inherit: {DEFAULT: 'text-inherit'},
            transparent: colors.transparent,
            warning: {...colors.yellow, DEFAULT: colors.yellow['500']},
            white: colors.white,
        },
        // Custom container styling
        container: {
            center: true,
            padding: '1rem',
            screens: {
                sm: '700px',
                md: '828px',
                lg: '984px',
                xl: '1240px',
                '2xl': '1496px',
            },
        },
        fontFamily: {
            sans: ['"Fira Sans"', ...defaultTheme.fontFamily.sans],
        },
        // Set the default font
        fontFamily: {
            sans: ['"Fira Sans"', ...defaultTheme.fontFamily.sans],
        },
        extend: {
            fontSize: {
                '6': '6px',
                '11': '11px',
                '13': '13px',
            },
            // Extend existing z-index classes
            zIndex: {
                '1': '1',
                '5': '5',
                '15': '15',
                '25': '25',
                '35': '35',
                '45': '45',
                '50': '50',
                '55': '55',
                '60': '60',
                '65': '65',
                '70': '70',
                '75': '75',
                '80': '80',
                '85': '85',
                '90': '90',
                '95': '95',
                '100': '100',
                '9998': '9998',
                '9999': '9999',
            },
            // Typography for prose class
            typography: (theme) => ({
                DEFAULT: {
                    css: getTypography(theme, {
                        '--tw-prose-body': theme('colors.black'),
                        '--tw-prose-bullets': theme('colors.black'),
                        '--tw-prose-counters': theme('colors.black'),
                        maxWidth: '100%',
                        ul: {
                            listStylePosition: 'outside',
                            listStyleType: 'disc',
                            paddingLeft: '2rem',
                        },
                        ol: {
                            listStylePosition: 'outside',
                            paddingLeft: '2rem',
                            marginTop: 0,
                            marginBottom: 0,
                        },
                        li: {
                            marginTop: 0,
                            marginBottom: 0,
                        },
                    }),
                },
            }),
        },
    },
    plugins: [
        'postcss-import',
        'tailwindcss',
        'autoprefixer',
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms')({
            strategy: 'base',
        }),
    ],
    safelist: [
        'max-w-20',
        'p-8',
        'w-20',
        'alert-warning',
    ],
};

function getTypography(theme, options) {
    const base = {
        'form': {marginBlockEnd: '0'},
        th: {
            textAlign: 'left',
            padding: '.5rem',
        },
        td: {
            textAlign: 'left',
            padding: '.5rem',
        },
    };
    return {...base, ...options};
}